/**
 * 蓝石集团审核专用页（/bluestone）· 登录态存取
 *
 * 为什么单独一套 key：审核页与购买页同域（h5.scrmai.com），localStorage 共用，
 * 购买页的 `token` 是微信授权态凭据，两者不能混用，否则会互相顶掉。
 */
const TOKEN_KEY = 'BLUESTONE_TOKEN'
const EXPIRE_AT_KEY = 'BLUESTONE_TOKEN_EXPIRE_AT'

/**
 * 保存登录态
 * @param {string} token 后端签发的 token
 * @param {number} expireAt 过期时间（毫秒时间戳，由后端下发）
 */
export function saveToken(token, expireAt) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(EXPIRE_AT_KEY, String(expireAt || 0))
}

/**
 * 读取 token（不判断是否过期）
 * @returns {string|null} token
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 清掉登录态
 */
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(EXPIRE_AT_KEY)
}

/**
 * 是否处于有效登录态（本地有 token 且未到过期时间）
 * @returns {boolean} true 已登录
 */
export function isLoggedIn() {
  if (!getToken()) {
    return false
  }
  const expireAt = Number(localStorage.getItem(EXPIRE_AT_KEY))
  if (!expireAt || expireAt <= Date.now()) {
    clearToken()
    return false
  }
  return true
}